var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9V6.2002C9.5 5.08009 9.5 4.51962 9.71799 4.0918C9.90973 3.71547 10.2155 3.40973 10.5918 3.21799C11.0196 3 11.5801 3 12.7002 3H18.3002C19.4203 3 19.9801 3 20.4079 3.21799C20.7842 3.40973 21.0905 3.71547 21.2822 4.0918C21.5002 4.51962 21.5002 5.07967 21.5002 6.19978V11.7998C21.5002 12.9199 21.5002 13.48 21.2822 13.9078C21.0905 14.2841 20.7839 14.5905 20.4076 14.7822C19.9802 15 19.421 15 18.3031 15H15.5M9.5 9H6.7002C5.58009 9 5.01962 9 4.5918 9.21799C4.21547 9.40973 3.90973 9.71547 3.71799 10.0918C3.5 10.5196 3.5 11.0801 3.5 12.2002V17.8002C3.5 18.9203 3.5 19.4801 3.71799 19.9079C3.90973 20.2842 4.21547 20.5905 4.5918 20.7822C5.0192 21 5.57899 21 6.69691 21H12.3036C13.4215 21 13.9805 21 14.4079 20.7822C14.7842 20.5905 15.0905 20.2839 15.2822 19.9076C15.5 19.4802 15.5 18.921 15.5 17.8031V15M9.5 9H12.3002C13.4203 9 13.9801 9 14.4079 9.21799C14.7842 9.40973 15.0905 9.71547 15.2822 10.0918C15.5 10.5192 15.5 11.079 15.5 12.1969L15.5 15",
    stroke: "#203E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy_blue.5ff870792bbd8579694b3124071ddbe5.svg";
export { ForwardRef as ReactComponent };